import React from "react";
import { useAudioStateContext } from "hooks/useAudioStateContext";
import { useAudioHandlesContext } from "hooks/useAudioHandlesContext";
import { HorizontalSlider } from "components/elements/HorizontalSlider";

export function Speed() {
    const state = useAudioStateContext();
    const handles = useAudioHandlesContext();

    return (
        <div className="x_flex-h">
            <div className="x_text-08">{state.playbackRate.toFixed(1)}×</div>
            <HorizontalSlider
                width={200}
                min={0.5}
                max={2}
                step={0.1}
                value={state.playbackRate}
                onValueChange={(val: number) => {
                    const fixVal = val.toFixed(1);
                    localStorage.setItem("playbackRate", `${fixVal}`);
                    handles.setPlaybackRate(+fixVal);
                }}
            />
        </div>
    );
}
